import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { DEFAULT_SPONSOR } from '../constants';
import { creditConfig } from '../config';
import { creditAppSelectors } from '../store/config';

/**
 * Custom hook to build credit app URL
 * Constructs the URL with dealer ID, theme, sponsor, and parent app name
 */
export const useCreditApp = () => {
    const { getDealerId, getTheme } = creditAppSelectors.additionalSelectors;
    const dealerId = useSelector(getDealerId);
    const theme = useSelector(getTheme);

    // Build standalone credit app URL - NO sessionId or dealXgId
    const creditAppUrl = useMemo(() => {
        const url = new URL(creditConfig.creditAppUrl);
        // Only include parameters required for STANDALONE mode
        url.searchParams.append('dealerId', String(dealerId));
        url.searchParams.append('sponsor', DEFAULT_SPONSOR);
        url.searchParams.append('theme', theme);
        url.searchParams.append('parentAppName', 'SalesCheckIn');

        return url.toString();
    }, [dealerId, theme]);

    return { creditAppUrl };
};
